(function () {
  'use strict';

  angular.module('app').component('providerList', providerList());

  function providerList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowItem: '&',
      },
      controller: ProviderListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/providers/provider-list/provider-list.component.html',
    };
  }

  ProviderListCtrl.$inject = [
    'UtilService',
    '$translate',
    '$filter',
    'AbilityService',
    'ProviderService',
    'ProviderTypeService',
  ];

  function ProviderListCtrl(
    UtilService,
    $translate,
    $filter,
    AbilityService,
    ProviderService,
    ProviderTypeService
  ) {
    var vm = this;

    $translate = $filter('translate');

    vm.permissions = {
      canShow: AbilityService.can('show_provider_accountadmin'),
      canUpdate: AbilityService.can('update_provider_accountadmin'),
      canDestroy: AbilityService.can('destroy_provider_accountadmin'),
    };

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = ProviderService.getFilterCriteria();

    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    vm.deleteItem = deleteItem;
    vm.changeItemStatus = changeItemStatus;
    vm.changeItemDefault = changeItemDefault;
    vm.onUpdateItems = onUpdateItems;

    // Initializers
    getProviderTypes();

    function getProviderTypes() {
      ProviderTypeService.getProviderTypes({ get: 'active' }).then(function (data) {
        vm.providerTypes = data.items;
        //vm.providerTypes.unshift({ name: $translate('SHOW_ALL') });
      });
    }

    function fetchResult() {
      vm.loadingItems = true;
      ProviderService.getProviders(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.filterCriteria = ProviderService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item, mode) {
      vm.onShowItem({ item: item, mode: mode });
    }

    function deleteItem(item) {
      ProviderService.deleteProvider(item, fetchResult);
    }

    function changeItemStatus(item) {
      ProviderService.changeProviderStatus(item);
    }

    function changeItemDefault(item) {
      ProviderService.changeProviderDefault(item, fetchResult);
    }

    function onUpdateItems(action) {
      var successCallback = function () {
        vm.showActions = false;
        vm.selectedAll = false;

        if (action === 'destroy') {
          fetchResult();
        }
      };

      ProviderService.updateProviders(action, vm.items, successCallback);
    }
  }
})();
